export default __webpack_public_path__ + "static/media/neuroshiiled-logo-2-3.e0a5aabd.jpg";